import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';

var Config = require('../../../config');

class ModalSampleResult extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.samples = this.samples.bind(this);
		this.getSamples = this.getSamples.bind(this);
		this.deleteSample = this.deleteSample.bind(this);

		this.state = {
			show: false,
			samples:[],
			petition_id:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(petition_id){
	
		this.getSamples(petition_id)
		this.setState({
			petition_id:petition_id
		});
	}

	getSamples(id){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'petitions/get_samples?petition_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){

				//this.setState({samples: response, show:true});
				if(response.length === 1){
					var sample_id = response[0].sample.id;
					
					this.props.history.push({
						pathname:'/sample_results/'+sample_id+'/'+this.state.petition_id+'/0',
						state:{
							from:this.props.location.pathname
						}
					})
				}else{
					this.setState({samples: response, show:true});
				}
			}
		});
	}

	handleClose(){
		this.setState({show:false});
	}

	samples(e, sample_id){
		e.preventDefault();
		this.props.history.push({
			pathname: '/sample_results/'+sample_id+'/'+this.state.petition_id+'/0',
			state: { 
			    from: this.props.location.pathname
			}
		});
	}

	deleteSample(e, id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'samples/'+id, {
		  			method : 'delete',
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.getSamples(this.state.petition_id);
		  				swal('Success', 'El registro se elimino correctamente', 'success');
		  			}	
		  		})
	        }
	    });
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Selección de muestra</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-offset-1 col-sm-10">
				        		<Table responsive hover>
				        			<thead>
				        				<tr>
				        					<th>Muestra</th>
											<th>Tipo</th>
				        					<th>Grupo & RH</th>
											<th>Lectina</th>
											<th>DU</th>
				        					<th>Fecha</th>
				        					<th>Estatus</th>
				        					<th></th>
				        				</tr>
				        			</thead>
				        			<tbody>
					        			{this.state.samples.map((s, i)=>(
						        			<tr key={i}>
						        				<td>
						        					<a href="" onClick={(e)=>this.samples(e, s.sample.id)}>
						        						{s.sample.number}
						        					</a>
						        				</td>
												<td>{s.sample.maternal_flag?"Materna":"Paciente"}</td>
						        				<td>
						        					{s.group+(
						        						s.rh === 'POSITIVO' ? '+' :
						        						s.rh === 'NEGATIVO' ? '-' : ''
						        					)}
						        				</td>
												<td>{s.lectina}</td>
												<td>{s.du}</td>
						        				<td>{moment(s.sample.timestamp).format('DD/MM/YYYY HH:mm')}</td>
						        				<td>
						        					{s.sample.expired_date !== null ?
						        						'CADUCADA'
						        					:''}
						        				</td>
						        				<td>
						        					<button className="btn btn-info btn-xs" title="Eliminar" 
														style={{marginRight:'3px'}} 
														onClick={(e) =>  this.deleteSample(e, s.sample.id)}>
							                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
							                        </button>
						        				</td>
						        			</tr>
						        		))}
					        		</tbody>
				        		</Table>
			        		</div>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalSampleResult)